import { render, staticRenderFns } from "./FormButtonAddElement.vue?vue&type=template&id=06652418&scoped=true&"
import script from "./FormButtonAddElement.vue?vue&type=script&lang=js&"
export * from "./FormButtonAddElement.vue?vue&type=script&lang=js&"
import style0 from "./FormButtonAddElement.vue?vue&type=style&index=0&id=06652418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06652418",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
